// OPARA - locale-aware route helpers
// Zero-Root Gateway: tum icerik /{locale}/ altinda. Sabit /giris gibi prefix'siz
// redirect'ler router'da /tr/...'ye yeniden yazilir -> non-TR kullanici locale kaybeder.
// Bu helper'lar dogru locale-prefix + locale'e gore slug uretir (App.js ile uyumlu).
//
// Slug-map (App.js):
//   login:          tr=giris,           diger=login
//   verify-pending: tr=email-dogrulama, diger=email-verification
//   home:           uniform /{locale}/

// Gecersiz/bos locale -> tr fallback (cagiranlar detectLanguageFromPath sonucu gecirir, hep gecerli).
const norm = (locale) => locale || 'tr';

export const getLoginPath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/giris' : `/${l}/login`;
};

export const getHomePath = (locale) => `/${norm(locale)}/`;

export const getVerifyPath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/email-dogrulama' : `/${l}/email-verification`;
};

// Davet-kabul slug-map (App.js): tr=davet-kabul (TurkishRoutes), diger=invitation (evrensel).
// Backend invite linki (server.py _invite_path) ile ayni harita.
export const getInvitePath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/davet-kabul' : `/${l}/invitation`;
};

// Google kayit-tamamlama slug-map (App.js): tr=google-kayit-tamamla (TurkishRoutes), diger=google-complete.
// Backend redirect (server.py _google_complete_path) ile ayni harita.
export const getGoogleCompletePath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/google-kayit-tamamla' : `/${l}/google-complete`;
};

// Kayit sayfasi slug-map (App.js): tr=kayit-ol (TurkishRoutes; /uye-ol route YOK), diger=register.
// Backend (server.py _signup_path) ile ayni harita.
export const getSignupPath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/kayit-ol' : `/${l}/register`;
};

// Paketler/fiyatlandirma slug-map (App.js): tr=kredi-paketleri (TurkishRoutes), diger=pricing.
// Backend (server.py:10731 cancel_url) ile ayni harita.
export const getPricingPath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/kredi-paketleri' : `/${l}/pricing`;
};

// Hukuki/ayarlar slug-map (App.js locale-tree'den okundu):
//   terms:    tr=kullanim-kosullari (:146), diger=terms
//   privacy:  tr=kvkk (:147),               diger=privacy   (KVKKPage)
//   about:    tr=hakkimizda (:150),         diger=about
//   settings: tr=hesap-ayarlari (:133),     diger=settings  (ProfilePage)
export const getTermsPath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/kullanim-kosullari' : `/${l}/terms`;
};
export const getPrivacyPath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/kvkk' : `/${l}/privacy`;
};
export const getAboutPath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/hakkimizda' : `/${l}/about`;
};
export const getSettingsPath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/hesap-ayarlari' : `/${l}/settings`;
};

// Kart/odeme-yontemi guncelleme slug-map (App.js): tr=odeme-yontemi, diger=payment-method.
// Dunning banner (UserStatusBar) + payment_failed e-postasi (email_service.py) bu helper'a baglanir.
export const getPaymentUpdatePath = (locale) => {
  const l = norm(locale);
  return l === 'tr' ? '/tr/odeme-yontemi' : `/${l}/payment-method`;
};
